// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockument {
   width: 100%;
   display: flex;
   flex-direction: column;
   overflow: hidden;
   padding: var(--padding);
   padding-top: 0px;
}

.blockument>h1 {
   width: 100%;
   padding-top: 0px;
}

.blockument-display-area {
   width: 100%;
}

.blockument-viz-container {
   width: 100%;
   flex: 1 0 250px;
}
`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/ECLBlockument.css"],"names":[],"mappings":"AAAA;GACG,WAAW;GACX,aAAa;GACb,sBAAsB;GACtB,gBAAgB;GAChB,uBAAuB;GACvB,gBAAgB;AACnB;;AAEA;GACG,WAAW;GACX,gBAAgB;AACnB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,WAAW;GACX,eAAe;AAClB","sourcesContent":[".blockument {\r\n   width: 100%;\r\n   display: flex;\r\n   flex-direction: column;\r\n   overflow: hidden;\r\n   padding: var(--padding);\r\n   padding-top: 0px;\r\n}\r\n\r\n.blockument>h1 {\r\n   width: 100%;\r\n   padding-top: 0px;\r\n}\r\n\r\n.blockument-display-area {\r\n   width: 100%;\r\n}\r\n\r\n.blockument-viz-container {\r\n   width: 100%;\r\n   flex: 1 0 250px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
